import Render from '@Views/root/help/how-it-works.html'
import { Vue, Component } from 'vue-property-decorator'
import {IBreadcrumbItem} from "@Store/types/breadcrumb";
import {breadcrumb} from "@Store/modules/breadcrumb";

@Render
@Component({})
export class HowItWorks extends Vue {
   mounted(){
     this.initializeBreadcrumb()
   }

	private initializeBreadcrumb(): void {
		let item1: IBreadcrumbItem = { label: this.$i18n.t('vm.root.breadcrumb.help').toString(), link: "help" }
		let item2: IBreadcrumbItem = { label: this.$i18n.t('vm.root.breadcrumb.how-it-works').toString() }
		breadcrumb.updateItems([item1, item2])
	}

	get pdfUrl(){
	   return "https://resources.osteo2ls.com/app/guide-help2ls.pdf#toolbar=0&navpanes=0&view=FitH";
	}
}
